/* Files Store */

import { downloadFile } from '@/api'

const state = {}

const actions = {
  downloadFile (context, fileId) {
    return downloadFile(fileId)
  }
}

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
